import { useTranslation } from 'next-i18next';
import React from 'react';

/**
 * 用户协议 / 隐私协议 / Cookie 政策等独立文档页底部页脚
 * 仅展示注册商标文案（不含 © 年份），字体/颜色与官网页脚版权行一致
 */
const AgreementPageFooter: React.FC = () => {
  const { t, i18n } = useTranslation('common');

  return (
    // 协议页容器内联了 PingFang/Roboto 字体，这里显式还原为官网字体，
    // 否则 ® 等符号的字形与官网页脚不一致
    <div
      className={`mb-8 mt-10 flex flex-col items-center px-5 text-xs text-wk-words-1 opacity-85 xl:mt-12 xl:text-sm ${
        i18n.language === 'en' ? 'font-figtree' : 'font-sans'
      }`}>
      <p className="mx-2 my-0.5 text-wk-words-2">{t('导航-注册商标')}</p>
    </div>
  );
};

export default AgreementPageFooter;
